

import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function TrendingStockModel(){
    const apiModel = ChartstwitsRepository();
const navigate = useNavigate();

    const [trendingStocks,setTrendingStocks] = useState([{
        symbol : "",
        name : "",
        lastSale : 0,
        netChange : 0,
        perChange : 0,
        marketCap : "",
        country : "",
        ipoyear : "",
        volume : 0,
        sector : "",
        industry : "",
        open : [] as any,
        currency : "",
        date : "",
        high : [] as any,
        low : [] as any,
        close : [] as any
    }])

    const viewStocks = async () =>{
        debugger;
        const responseData:any = await apiModel.getStocks();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setTrendingStocks(responseData)
        }
    }

    const viewStockDetails = (d:any) =>{
              const queryParams = {
                ticker: d.symbol,
            };
            const queryString = new URLSearchParams(queryParams).toString();
            navigate(`/ticker-details?${queryString}`);
    }

    useEffect(()=>{
        viewStocks();
    },[alert]);


    return{trendingStocks,viewStockDetails}

}